import React from 'react';
import { X, Upload, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const HeroBannerSection = ({ brandingData, setBrandingData, heroFileRef, uploadingHero, onHeroImageUpload }) => (
  <>
    <div>
      <Label>Imagem do Banner (Hero)</Label>
      <div className="mt-2 space-y-3">
        {brandingData.hero_image_url && (
          <div className="relative rounded-lg overflow-hidden border border-slate-200">
            <img
              src={`${process.env.REACT_APP_BACKEND_URL}${brandingData.hero_image_url}`}
              alt="Hero banner preview"
              className="w-full h-40 object-cover"
            />
            <button
              onClick={() => setBrandingData(prev => ({ ...prev, hero_image_url: '' }))}
              className="absolute top-2 right-2 p-1 bg-red-500 text-white rounded-full hover:bg-red-600"
              title="Remover imagem"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        )}

        <div className="flex gap-2">
          <input
            type="file"
            ref={heroFileRef}
            onChange={onHeroImageUpload}
            accept="image/*"
            className="hidden"
            data-testid="hero-file-input"
          />
          <Button
            variant="outline"
            onClick={() => heroFileRef.current?.click()}
            disabled={uploadingHero}
            data-testid="upload-hero-btn"
          >
            {uploadingHero ? (
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            ) : (
              <Upload className="w-4 h-4 mr-2" />
            )}
            {uploadingHero ? 'A carregar...' : 'Carregar Imagem'}
          </Button>
        </div>
        <p className="text-sm text-slate-500">
          Recomendado: 1920x400px, JPEG ou PNG, máximo 5MB
        </p>
      </div>
    </div>

    <div>
      <Label htmlFor="hero_title">Título do Banner</Label>
      <Input
        id="hero_title"
        value={brandingData.hero_title}
        onChange={(e) => setBrandingData(prev => ({ ...prev, hero_title: e.target.value }))}
        placeholder="Canal de Denúncias Interno"
        data-testid="hero-title-input"
      />
    </div>

    <div>
      <Label htmlFor="hero_subtitle">Subtítulo do Banner</Label>
      <Input
        id="hero_subtitle"
        value={brandingData.hero_subtitle}
        onChange={(e) => setBrandingData(prev => ({ ...prev, hero_subtitle: e.target.value }))}
        placeholder="Submeta a sua denúncia de forma segura e confidencial"
        data-testid="hero-subtitle-input"
      />
    </div>
  </>
);
